import { Condition } from "@app/rule/model/conditions/condition";
import { MultiCondition, MultiConditionHelper } from "@app/rule/model/conditions/multi-condition";
import {
    PropertyChangeCondition,
    PropertyChangeConditionHelper,
} from "@app/rule/model/conditions/property-change-condition";
import { TimerCondition } from "./timer-condition";
import { UICondition, UIConditionHelper } from "./ui-condition";

export {
    Condition,
    UICondition,
    UIConditionHelper,
    PropertyChangeCondition,
    MultiCondition,
    MultiConditionHelper,
    PropertyChangeConditionHelper,
};

export type ConditionType =
    | Condition
    | UICondition
    | PropertyChangeCondition
    | MultiCondition
    | TimerCondition;
